"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AlertInfo = (0, _createIcon["default"])({
  path: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5ZM11.7223 8C10.828 8 10.2318 7.33309 10.2504 6.50981C10.2318 5.64675 10.828 5 11.7404 5C12.6533 5 13.2309 5.64729 13.25 6.50981C13.2495 7.33309 12.6538 8 11.7223 8ZM9.5 9.75C9.08579 9.75 8.75 10.0858 8.75 10.5C8.75 10.9142 9.08579 11.25 9.5 11.25H11V16.25H9.5C9.08579 16.25 8.75 16.5858 8.75 17C8.75 17.4142 9.08579 17.75 9.5 17.75H14.5C14.9142 17.75 15.25 17.4142 15.25 17C15.25 16.5858 14.9142 16.25 14.5 16.25H13V10.5C13 10.0858 12.6642 9.75 12.25 9.75H9.5Z",
  // prettier-ignore
  viewBox: '24 24',
  displayName: 'AlertInfo',
  icon: 'info'
});
var _default = exports["default"] = AlertInfo;